import { useEffect, FC } from 'react';

import { useRootStore } from '../../../../../root/RootStoreHooks';

export const Cybersource3ds: FC = () => {
  const store = useRootStore().moduleStores.threeDSecureEntry?.cybersource3ds;

  useEffect(() => {
    if (store?.isEnabled) {
      store.initAuth();
    }
  }, [store, store?.isEnabled]);

  return null;
};
